import React from "react";
import Page from "../Page/Page";

const RootPage: React.FC = () => {

    return <Page></Page>;
};

export default RootPage;
